import { useVariantSelectionState } from '../context/VariantSelectionContext';
import { makeVariantPrice } from '../util/make-variant-price';
import type { ProductPricingTypeEnum } from 'generated/graphql';
import { variantHasPrice } from '../util/variant-has-price';
import { useLocalisation } from '@archipro-website/localisation';

const useVariantPrice = (
    pricingType: ProductPricingTypeEnum,
): ReturnType<typeof makeVariantPrice> => {
    const { selectedVariant } = useVariantSelectionState();
    const { countryConfig } = useLocalisation();
    const hasPrice = selectedVariant
        ? variantHasPrice(selectedVariant, pricingType)
        : false;

    return makeVariantPrice(
        hasPrice,
        selectedVariant,
        pricingType,
        countryConfig.measurementSystem,
    );
};

export default useVariantPrice;
